// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".default-text[data-v-04d00dfd] .v-input__append-outer{margin:4px;height:100%}", ""]);
// Exports
module.exports = exports;
